/**
 * Search Interaction Handler
 * Manages the interaction between trending section and predictive search
 */
document.addEventListener('DOMContentLoaded', function() {
  const searchInputs = document.querySelectorAll('.search-modal__form .search__input');
  const trendingSections = document.querySelectorAll('.search-modal__trending');
  
  if (!searchInputs.length || !trendingSections.length) return;
  
  // Function to show trending section
  function showTrending() {
    trendingSections.forEach(section => {
      section.style.display = 'block';
    });
    
    // Hide predictive search results
    document.querySelectorAll('.predictive-search--header').forEach(results => {
      results.style.visibility = 'hidden';
    });
  }
  
  // Function to hide trending section
  function hideTrending() {
    trendingSections.forEach(section => {
      section.style.display = 'none';
    });
    
    // Show predictive search results
    document.querySelectorAll('.predictive-search--header').forEach(results => {
      results.style.visibility = 'visible';
    });
  }
  
  // Set up event listeners for each search input
  searchInputs.forEach(input => {
    // Initial state - show trending if input is empty
    if (input.value.trim() === '') {
      showTrending();
    } else {
      hideTrending();
    }
    
    // Hide trending when typing starts
    input.addEventListener('input', function() {
      if (this.value.trim() === '') {
        showTrending();
      } else {
        hideTrending();
      }
    });
    
    // Handle focus events
    input.addEventListener('focus', function() {
      if (this.value.trim() !== '') {
        hideTrending();
      }
    });
    
    // Handle reset button clicks
    const form = input.closest('form');
    if (form) {
      const resetButton = form.querySelector('.reset__button');
      if (resetButton) {
        resetButton.addEventListener('click', function() {
          // Small delay to ensure the input is cleared
          setTimeout(() => {
            showTrending();
          }, 10);
        });
      }
    }
  });
  
  // Watch for predictive search results appearing
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any search input has text
        let hasSearchText = false;
        searchInputs.forEach(input => {
          if (input.value.trim() !== '') {
            hasSearchText = true;
          }
        });
        
        // If there's search text, ensure trending is hidden
        if (hasSearchText) {
          hideTrending();
        }
      }
    });
  });
  
  // Observe predictive search containers for changes
  document.querySelectorAll('.predictive-search--header').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
  
  // Handle modal opening
  document.querySelectorAll('.header__icon--search').forEach(searchIcon => {
    searchIcon.addEventListener('click', function() {
      setTimeout(() => {
        // Check if any search input has text when modal opens
        let hasSearchText = false;
        searchInputs.forEach(input => {
          if (input.value.trim() !== '') {
            hasSearchText = true;
          }
        });
        
        if (hasSearchText) {
          hideTrending();
        } else {
          showTrending();
        }
      }, 50);
    });
  });
}); 